module.exports = __webpack_public_path__ + "img/scholarship2.17b52288.png";